'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// :: Component => String
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

exports.default = getDisplayName;


//////////////////
// WEBPACK FOOTER
// ./~/react-component-queries/commonjs/utils/getDisplayName.js
// module id = 566
// module chunks = 168707334958949